interface MyAccount {
  settings: string;
  giftCardCount?: string;
  searchTerm?: string;
  searchBy?: string;
}

interface Error {
  type?: string;
  displayType?: string;
  pageSection?: string;
  message?: string;
  code?: string;
}

interface Event {
  category?: {
    primaryCategory: string;
  };
  eventInfo?: {
    eventName: string;
    error?: errors;
    giftCardsSelected?: string;
  };
  giftCardsSelected?: string;
  stash?: {
    myAccount?: MyAccount;
  };
  eventMode?: string;
  myAccount?: MyAccount;
  type?: string;
  displayType?: string;
  pageSection?: string;
  message?: string;
  code?: string;
}

const setButtonEventObj = () => {
  const buttonEventsObj = {
    category: {
      primaryCategory: 'button submission'
    },
    eventInfo: {
      eventName: 'my account settings'
    }
  };

  return buttonEventsObj;
};

const setOverlayEventObj = (action: string, secondaryAction?: string) => {
  const overlayEventsObj: Event = {
    category: {
      primaryCategory: 'overlay'
    }
  };

  if (action) {
    let _eventName = `${action} gift card`;
    if (secondaryAction) {
      _eventName = `${_eventName}: ${secondaryAction}`;
    }
    overlayEventsObj.eventInfo = {
      eventName: _eventName
    };
  }

  return overlayEventsObj;
};

const setStashEvent = () => {
  const stashEventsObj = {
    category: {
      primaryCategory: 'stash'
    },
    eventInfo: {
      eventName: 'my account settings'
    },
    eventMode: 'stash'
  };

  return stashEventsObj;
};

const setErrorEventObj = () => {
  const errors: Error[] = [];
  const errorEventsObj = {
    category: {
      primaryCategory: 'error'
    },
    eventInfo: {
      eventName: 'post page error',
      error: errors
    }
  };
  return errorEventsObj;
};

const pushPageErrorEventData = (eventData: Event) => {
  try {
    const _ddo = window?.digitalData.init();
    window._T = window._T || {};
    if (typeof window._T.pageData === 'undefined') {
      window._T.pageData = [];
    }
    _ddo.page = _ddo.page || {};
    _ddo.page.error = _ddo.page.error || [];
    _ddo.page.error.push(eventData);
    window._T.pageData.push(_ddo);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('DDO : Error in pushing the event info!!!');
  }
};

export const setOverlayEvent = (primaryAction: string, secondaryAction?: string) => {
  if (typeof window === 'undefined' || !window?.digitalData) {
    return;
  }
  const eventData: Event = setOverlayEventObj(primaryAction, secondaryAction);
  try {
    window.digitalData?.event.push(eventData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('DDO : Error in pushing the event info!!!');
  }
};

export const setButtonEvent = (settings: string) => {
  if (typeof window === 'undefined' || !window?.digitalData) {
    return;
  }
  const eventData: Event = setButtonEventObj();
  eventData.myAccount = {
    settings
  };

  try {
    window.digitalData?.event.push(eventData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('DDO : Error in pushing the event info!!!');
  }
};

export const setSavedGiftCardPageLoadEvent = (total: string) => {
  if (typeof window === 'undefined' || !window?.digitalData) {
    return;
  }
  const eventData: Event = setButtonEventObj();
  eventData.myAccount = {
    settings: 'cards and accounts: tender: gift cards',
    giftCardCount: total
  };
  try {
    window.digitalData?.event.push(eventData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('DDO : Error in pushing the event info!!!');
  }
};

export const setSavedGiftCardPageLoadErrorEvent = (message?: string) => {
  if (typeof window === 'undefined' || !window?.digitalData) {
    return;
  }
  const eventData = {
    type: 'system',
    displayType: 'page',
    pageSection: 'my account settings',
    message
  };
  pushPageErrorEventData(eventData);
};

export const setErrorEvent = (overlay: string, message?: string, code?: string) => {
  if (typeof window === 'undefined' || !window?.digitalData) {
    return;
  }
  const thdAnalyticsEvent = setErrorEventObj();
  const eventData: Error = {
    type: 'error',
    displayType: 'inline',
    pageSection: `${overlay} gift card`,
    message,
    code: code || 'n/a'
  };
  thdAnalyticsEvent.eventInfo.error[0] = eventData;
  try {
    window.digitalData?.event.push(thdAnalyticsEvent);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('DDO : Error while deleting gift card');
  }
};

export const setViewpurchasesEvent = () => {
  if (typeof window === 'undefined' || !window?.digitalData) {
    return;
  }
  const thdAnalyticsEvent: Event = setStashEvent();
  thdAnalyticsEvent.stash = {
    myAccount: {
      settings: 'cards and accounts: gift cards: meatball: view purchases'
    }
  };
  try {
    window.digitalData?.event.push(thdAnalyticsEvent);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('DDO : Error on click of view purchase meantball option event');
  }
};

export const setSortEvent = (sortBy: string) => {
  if (typeof window === 'undefined' || !window?.digitalData) {
    return;
  }

  const eventData: Event = setButtonEventObj();
  eventData.myAccount = {
    settings: 'cards and accounts: grid: gift cards: sort',
    searchBy: 'n/a',
    searchTerm: `gift card: ${sortBy.toLocaleLowerCase()}`
  };

  try {
    window.digitalData?.event.push(eventData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('DDO : Error in pushing the event info!!!');
  }
};

export const setViewBarcodeEvent = (cardNum: number) => {
  if (typeof window === 'undefined' || !window?.digitalData) {
    return;
  }

  const eventData: Event = setButtonEventObj();
  eventData.eventInfo = {
    eventName: 'view barcode button click'
  };
  eventData.giftCardsSelected = `gift cards selected: ${cardNum}`;

  try {
    window.digitalData?.event.push(eventData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('DDO : Error in pushing the event info!!!');
  }
};
